import { render, staticRenderFns } from "./LandingPageSetup.vue?vue&type=template&id=8b0ebc84&scoped=true&"
import script from "./LandingPageSetup.vue?vue&type=script&lang=js&"
export * from "./LandingPageSetup.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageSetup.vue?vue&type=style&index=0&id=8b0ebc84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0ebc84",
  null
  
)

export default component.exports